import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { scroller } from 'react-scroll';

import { MuiStack } from '../../../../../../../modules/material';
import { PricingProductOptionsGroup } from '../../../../../store/features/products/types';
import { PricingPackagesFormValues } from '../../../../../store/features/packages/types';
import { useRootSelector } from '../../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../../store/features/pageConfig';
import { PricingProductSelectionTypes } from '../../../../../types/enums';

import MultipleOptionsList from './MultipleOptionsList';
import SingleOptionsList from './SingleOptionsList';

export interface ProductOptionsProps {
  options: PricingProductOptionsGroup[];
}

export default function ProductOptions(props: ProductOptionsProps) {
  const { options } = props;
  const pageConfig = useRootSelector(selectPageConfig);

  const {
    formState: { errors },
  } = useFormContext<PricingPackagesFormValues>();

  const firstErrorId = Object.keys(
    errors.productsSelections?.optionsMultipleMap || {},
  )[0];
  const isMultipleOptionsError =
    errors.productsSelections?.optionsMultipleMap?.[firstErrorId];

  useEffect(() => {
    if (isMultipleOptionsError) {
      const scrollOffset = 50;
      const {
        elementsProperties: {
          multiLevelNavMenu: { height: navMenuHeight = 0 } = {},
        } = {},
      } = pageConfig;

      scroller.scrollTo(
        `productsSelections.optionsMultipleMap.${firstErrorId}`,
        {
          duration: 100,
          smooth: true,
          offset: -(navMenuHeight + scrollOffset),
        },
      );
    }
  }, [isMultipleOptionsError, firstErrorId, pageConfig]);

  return (
    <MuiStack spacing={2} className="informa-payment-product-options">
      {options.map((optionGroup, index) => {
        const isMultipleChoice =
          optionGroup.type === PricingProductSelectionTypes.MULTIPLE_CHOICE;
        const key = `${optionGroup.type}-${index}`;

        if (isMultipleChoice) {
          return (
            <MultipleOptionsList
              optionGroup={optionGroup}
              index={index}
              key={key}
            />
          );
        }

        return (
          <SingleOptionsList
            optionGroup={optionGroup}
            index={index}
            key={key}
          />
        );
      })}
    </MuiStack>
  );
}
